import { List, Map } from "immutable";
import { formatMessage } from "lib/globalize-util";
import { TargetGroupWithTargets } from "../../types";

export enum ERROR_MESSAGES {
    INVALID_NAME = "A Target already exists with this name.",
}

export const validateTargetName = (
    value: string,
    targetGroups: List<Map<string, any>>,
    currentTarget?: TargetGroupWithTargets
): string | true => {
    const currentTargetName = currentTarget?.name;
    if (currentTargetName && currentTargetName === value) {
        return true;
    }

    const hasNoDuplicate = targetGroups.every((g) => {
        //TODO once we fix the lack of struct_value after adding a target this should be refactored
        const targetName = g.getIn(["struct_value", "name"]) || g.get("name");
        return targetName.toLowerCase().trim() !== value.toLowerCase().trim();
    });

    return hasNoDuplicate ? true : formatMessage(ERROR_MESSAGES.INVALID_NAME);
};
